/**
 * Build a URL with query parameters.
 * Handles arrays, skips null/undefined/empty values.
 *
 * @param baseUrl - The base URL or path
 * @param params - An object of query parameters
 * @returns string - Fully constructed URL with query string
 */
export function buildUrlWithQuery(baseUrl: string, params: Record<string, any>): string {
    const url = new URL(baseUrl, window.location.origin);

    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === '' || value === undefined) return;

        if (Array.isArray(value)) {
            value.forEach((v) => url.searchParams.append(`${key}[]`, String(v)));
        } else {
            url.searchParams.append(key, String(value));
        }
    });

    return url.toString();
}
